import React from 'react';

import { useGetProductTemplateConfig } from 'api/api-hooks/product-templates-hooks';
import { GanttChartConfigProps } from 'components/ComponentType';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { TabPanel, TabView } from 'primereact/tabview';
import { T } from 'services/lang/LanguageService';
import GanttRanges from './GanttRanges';
import GanttTimestamps from './GanttTimestamps';

const GanttChartConfig: React.FC<GanttChartConfigProps> = ({ currentConfig, setCurrentConfig }) => {

  const {data} = useGetProductTemplateConfig(
    currentConfig.safeName,
    `${currentConfig.id}`,
    [],
    [],
    {
      enabled: !!currentConfig.safeName && !Number.isNaN(Number(currentConfig.id)),
    }
  );

  return (
    <div>
      <div className="flex justify-content-start">
        <div className="w-5 md:w-3 gap-2 flex flex-column justify-content-center">
          <label htmlFor="columnOverrideYLabels">{T("word.column-override-y-labels")}</label>
          <Dropdown
            value={currentConfig.columnOverrideYLabels ?? ""}
            options={data?.data?.attributes}
            optionLabel="displayName"
            optionValue="referenceName"
            placeholder={T("word.select-one")}
            showClear
            id="columnOverrideYLabels"
            className="p-inputtext-sm w-14rem"
            onChange={e => setCurrentConfig(prev => ({ ...prev, [e.target.id]: e.target.value }))}
          />
        </div>
        <div className="w-5 md:w-2 gap-2 flex flex-column justify-content-center">
          <label htmlFor="height">{T("word.height")}</label>
          <InputNumber
            id="height"
            value={currentConfig?.height}
            placeholder={T("action.write-value")}
            className="p-inputtext-sm"
            suffix="px"
            onValueChange={e =>
              setCurrentConfig(prev => ({ ...prev, [e.target.id]: e.target.value }))
            }
          />
        </div>
      </div>
      <TabView className="w-full" panelContainerClassName="px-0">
        <TabPanel header={T("word.time-ranges")}>
          <GanttRanges
            data={data}
            currentConfig={currentConfig}
            setCurrentConfig={setCurrentConfig}
          />
        </TabPanel>
        <TabPanel header={T("word.timestamps")}>
          <GanttTimestamps
            data={data}
            currentConfig={currentConfig}
            setCurrentConfig={setCurrentConfig}
          />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default GanttChartConfig